import { PropsWithChildren } from 'react';
import { Paper } from '@mui/material';

import styles from './Page.module.css';

/**
 * Shell for one section of the query's configuration. Each section is its own card so the page reads as a set of
 * independent decisions — the body is a row, which is what pairs a "what the board uses" list with its source list.
 */
export default function EditorCard(props: PropsWithChildren<{ title: string }>) {
  return (
    <Paper
      variant='outlined'
      className={styles.card}
    >
      <h3 className={styles['card-title']}>{props.title}</h3>

      <div className={styles['card-body']}>{props.children}</div>
    </Paper>
  );
}
